import { GzFormFieldWebComponent } from '../../ui/gzForm/formField';

export class FormGroupHelper {
  public static setDisabledFormFields(disable: boolean, formFieldElements: Array<GzFormFieldWebComponent>): void {
    formFieldElements.forEach(formField => {
      formField.disabled = disable;
    });
  }
}
